import { ProductInspectionSampleDto } from "libs/shared-models/production-management/src/lib/product-inspection/product-inspection-samples.dto";
import { EntityRepository, Repository } from "typeorm";
import { ProductInspectionSamples } from "./product-inspection-samples.entity";

@EntityRepository(ProductInspectionSamples)
export class ProductInspectionSamplesRepository extends Repository<ProductInspectionSamples> {

}